export type BillingPeriod = 'monthly' | 'yearly'

export type PlanFeatureItem = {
  label: string
  included: boolean
  highlight?: boolean
}

export type PlanCardCopy = {
  plan: string
  tagline: string
  features: PlanFeatureItem[]
  recommended?: boolean
}

/** Landing-aligned copy (provisium-web pricing.yaml). */
export const planCardsCopy: PlanCardCopy[] = [
  {
    plan: 'start',
    tagline: 'Мои прайсы и заявка для одного заведения',
    features: [
      { label: 'Единый каталог и динамика цен', included: true },
      { label: 'До 3 поставщиков в «Моих прайсах»', included: true },
      { label: 'Обновление прайса 1 раз в 10 дней', included: true },
      { label: '1 пользователь и 1 заведение', included: true },
      { label: 'Заявка в PDF и текст для мессенджера', included: true },
    ],
  },
  {
    plan: 'month',
    tagline: 'Всё из «Старта», без лимитов на прайсы',
    features: [
      { label: 'Всё из тарифа «Старт»', included: true },
      { label: 'Без лимита поставщиков в «Моих прайсах»', included: true },
      { label: 'Обновление прайсов без ограничений', included: true },
      { label: '1 заведение в базе, доп. — +1 990 ₽/мес', included: true },
      { label: 'Команда до 3 пользователей', included: true },
    ],
  },
  {
    plan: 'year',
    tagline: 'Тот же полный доступ, оплата сразу за год',
    recommended: true,
    features: [
      { label: 'Всё из тарифа «Месяц»', included: true },
      { label: 'Сразу 2 заведения без доплаты', included: true, highlight: true },
      { label: 'Фиксированная цена на 12 месяцев', included: true },
      { label: 'Экономия ≈ 30 000 ₽ к помесячной оплате с 2-м заведением', included: true },
      { label: 'Удобно для планирования бюджета', included: true },
    ],
  },
]

export const computePremiumQuote = (
  venueCount: number,
  baseMonthlyRub: number,
  baseYearlyRub: number,
  baseVenues: number,
  addonMonthlyRub: number,
  addonYearlyRub: number,
) => {
  const venues = Math.max(1, venueCount)
  const addonSlots = Math.max(0, venues - baseVenues)
  return {
    venueCount: venues,
    addonVenueSlots: addonSlots,
    monthlyRub: baseMonthlyRub + addonSlots * addonMonthlyRub,
    yearlyRub: baseYearlyRub + addonSlots * addonYearlyRub,
  }
}

export const yearlySavingsRub = (monthlyRub: number, yearlyRub: number) =>
  Math.max(0, monthlyRub * 12 - yearlyRub)

export const resolvePlanCardsCopy = (
  catalog: Array<{
    plan: string
  }>,
): PlanCardCopy[] =>
  planCardsCopy.filter((card) => catalog.some((item) => item.plan === card.plan))
